/**
 * L'Almanax (GDD §10). Module pur.
 *
 * Une offrande par jour, tirée de la date elle-même : c'est le rendez-vous
 * quotidien du jeu. Il oblige aussi à garder un fond de stock au lieu de tout
 * vendre ou de tout crafter.
 */
import type { Contenu } from "./contenu.ts"
import { alea } from "./alea.ts"

/** Bonus d'XP accordé pendant 24 h, en %. */
export const BONUS_ALMANAX = 50
const JOUR_MS = 24 * 3600_000

/** Clé du jour, en UTC, la même pour tout le monde. */
export function jourDe(maintenant: number): string {
  return new Date(maintenant).toISOString().slice(0, 10)
}

/** Graine dérivée de la date : l'offrande est la même pour tous, chaque jour. */
function graineJour(jour: string): number {
  let h = 2166136261
  for (let i = 0; i < jour.length; i++) {
    h ^= jour.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

export interface Offrande {
  item: number
  qte: number
}

/** L'offrande du jour, tirée parmi les ressources récoltables. */
export function offrandeDuJour(c: Contenu, maintenant: number): Offrande | null {
  const jour = jourDe(maintenant)
  const pool = Object.values(c.recoltes).map((r) => r.item)
  if (pool.length === 0) return null
  const rng = alea(graineJour(jour))
  const item = pool[Math.floor(rng() * pool.length)]!
  const qte = 5 + Math.floor(rng() * 16)
  return { item, qte }
}

/** Le bonus court-il encore ? */
export const almanaxActif = (jusqua: number | null, maintenant: number) =>
  jusqua !== null && maintenant < jusqua

export const finAlmanax = (maintenant: number) => maintenant + JOUR_MS
